export enum CUSTOM_CSS_NAMES {
  FLOATING_CONTAINER = "au-floating-container",
  CONVERSION_BOX_CONTAINER = "au-conversion-box-container",
  CTA_BUTTON = "au-cta-button",
  CTA_BUTTONS_CONTAINER = "au-cta-buttons-container",
  PRICE_RATING_WIDGET_CONTAINER = "au-price-rating-widget-container",
}
